<div class="d-flex flex-column h-100">
  <label class="label-preview-title">{{item.templateOptions.label}} @if (item.templateOptions.required) {
    <span>*</span>
  }</label>
  <div class="h-100 d-flex flex-column justify-content-center">
    <div style="position: relative;">
      <input #startDate="bsDatepicker"
        [formControl]="dateControl"
        name="startDate"
        class="form-control custom-form-control"
        id="form-control"
        bsDatepicker
        autocomplete="off"
        [bsConfig]="{ containerClass: 'theme-blue', customTodayClass: 'datepicker-today', adaptivePosition: true, dateInputFormat: 'DD-MM-YYYY'}">
      @if (dateControl?.value) {
        <span class="date-cancel" (click)="cancelDate()"><img src="assets/img/close.svg" width="9px"></span>
      }
    </div>
    @if (dateControl.invalid && dateControl.errors['required'] && dateControl.touched) {
      <p class="validation-text pb-0 text-start">{{ 'MAIN.CONTENT.WORKFLOW.REQUIRED' | translate }}</p>
    }
  </div>
  <!-- <div class="estimated-duration-wrapper">
  <timepicker formControlName="time" [showMeridian]="false" ></timepicker>
</div> -->
</div>